import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { formateDate, formateDateWithMonth } from "../../../../utils/commonfunction";
import * as iapTransactionServices from "../../services/iapTransaction.services";
import { useTranslation } from "react-i18next";

const CURRENCY_SYMBOLS = {
  INR: "₹",
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  AUD: "A$",
  CAD: "C$",
};

const formatCurrency = (amount, currency) => {
  if (amount === null || amount === undefined) return "N/A";
  const symbol = currency ? (CURRENCY_SYMBOLS[currency.toUpperCase()] || currency + " ") : "";
  return `${symbol}${amount}`;
};

const formatPlatform = (platform) => {
  if (!platform) return "N/A";
  return platform.toUpperCase();
};

const EVENT_TYPE_COLORS = {
  PURCHASE: "badge-success",
  RENEWAL: "badge-info",
  RESTORE: "badge-primary",
  CANCEL: "badge-warning",
  EXPIRED: "badge-secondary",
  REFUND: "badge-danger",
  REVOKE: "badge-danger",
  GRACE_PERIOD: "badge-warning",
  FAIL_TO_RENEW: "badge-danger",
  OFFER_REDEEMED: "badge-info",
  PRICE_INCREASE: "badge-secondary",
  OTHER: "badge-secondary",
};

const IapTransactionView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    // { title: t("sidebar_link_subscribe"), url: "" },
    { title: t("sidebar_link_transactions"), url: "/admin/transactions/list/1" },
    { title: t("link_view"), url: "" },
  ];

  useEffect(() => {
    iapTransactionServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="main-content-label mb-3">
                {t("sidebar_link_transactions")}
              </h6>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">

                    {/* ── User Info ── */}
                    <h6 className="main-content-label mb-2 mt-3">User Info</h6>
                    <table className="table table-bordered table-hover mb-4">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Name</th>
                          <td>
                            {showdefault?.user?.full_name ||
                              (showdefault?.user?.first_name
                                ? `${showdefault.user.first_name} ${showdefault.user.middle_name || ""} ${showdefault.user.last_name || ""}`.replace(/\s+/g, " ").trim()
                                : "N/A")}
                          </td>
                        </tr>
                        {showdefault?.user?.username ? (
                          <tr>
                            <th>Username</th>
                            <td>{showdefault.user.username}</td>
                          </tr>
                        ) : null}
                        <tr>
                          <th>{t("label_email")}</th>
                          <td>{showdefault?.user?.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_phone_number")}</th>
                          <td>
                            {showdefault?.user?.countryCode && showdefault?.user?.phone_number
                              ? `${showdefault.user.countryCode} ${showdefault.user.phone_number}`
                              : showdefault?.user?.phone_number || "N/A"}
                          </td>
                        </tr>
                        {showdefault?.user?.profile_image ? (
                          <tr>
                            <th>{t("label_profile_picture")}</th>
                            <td>
                              <img
                                src={showdefault.user.profile_image}
                                alt="profile"
                                style={{ height: "60px", width: "60px", borderRadius: "50%", objectFit: "cover" }}
                              />
                            </td>
                          </tr>
                        ) : null}
                        {showdefault?.user?.createdAt ? (
                          <tr>
                            <th>User Joined</th>
                            <td>{formateDateWithMonth(showdefault.user.createdAt)}</td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>

                    {/* ── Transaction Info ── */}
                    <h6 className="main-content-label mb-2 mt-3">Transaction Info</h6>
                    <table className="table table-bordered table-hover mb-4">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Event Type</th>
                          <td>
                            <span className={`badge ${EVENT_TYPE_COLORS[showdefault?.event_type] || "badge-secondary"}`}>
                              {showdefault?.event_type ? showdefault.event_type.replace(/_/g, " ") : "N/A"}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th>Platform</th>
                          <td>{formatPlatform(showdefault?.platform)}</td>
                        </tr>
                        <tr>
                          <th>Source</th>
                          <td>{showdefault?.source || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Environment</th>
                          <td>{showdefault?.environment || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Paid Amount</th>
                          <td>{formatCurrency(showdefault?.paid_amount, showdefault?.currency)}</td>
                        </tr>
                        {showdefault?.product_id ? (
                          <tr>
                            <th>Product ID</th>
                            <td style={{ wordBreak: "break-word" }}>{showdefault.product_id}</td>
                          </tr>
                        ) : null}
                        {showdefault?.transaction_id ? (
                          <tr>
                            <th>Transaction ID</th>
                            <td style={{ wordBreak: "break-word" }}>{showdefault.transaction_id}</td>
                          </tr>
                        ) : null}
                        {showdefault?.original_transaction_id ? (
                          <tr>
                            <th>Original Transaction ID</th>
                            <td style={{ wordBreak: "break-word" }}>{showdefault.original_transaction_id}</td>
                          </tr>
                        ) : null}
                        {showdefault?.order_id ? (
                          <tr>
                            <th>Order ID</th>
                            <td style={{ wordBreak: "break-word" }}>{showdefault.order_id}</td>
                          </tr>
                        ) : null}
                        {showdefault?.purchase_token ? (
                          <tr>
                            <th>Purchase Token</th>
                            <td style={{ wordBreak: "break-all", fontSize: "12px" }}>{showdefault.purchase_token}</td>
                          </tr>
                        ) : null}
                        {showdefault?.notification_type ? (
                          <tr>
                            <th>Notification Type</th>
                            <td>{showdefault.notification_type}</td>
                          </tr>
                        ) : null}
                        {showdefault?.notification_subtype ? (
                          <tr>
                            <th>Notification Subtype</th>
                            <td>{showdefault.notification_subtype}</td>
                          </tr>
                        ) : null}
                        <tr>
                          <th>Purchase Date</th>
                          <td>{showdefault?.purchase_date ? formateDateWithMonth(showdefault.purchase_date) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Expires Date</th>
                          <td>{showdefault?.expires_date ? formateDateWithMonth(showdefault.expires_date) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault?.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* ── Plan Info ── */}
                    {showdefault?.subscription_plan && Object.keys(showdefault.subscription_plan).length > 0 ? (
                      <>
                        <h6 className="main-content-label mb-2 mt-3">Plan Info</h6>
                        <table className="table table-bordered table-hover mb-4">
                          <tbody>
                            <tr>
                              <th style={{ width: "30%" }}>{t("list_heading_title")}</th>
                              <td>{showdefault.subscription_plan?.title || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("list_heading_price")}</th>
                              <td>
                                {showdefault.subscription_plan?.price !== null &&
                                showdefault.subscription_plan?.price !== undefined
                                  ? `₹${showdefault.subscription_plan.price}`
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>{t("list_heading_duration_type")}</th>
                              <td className="text-capitalize">
                                {showdefault.subscription_plan?.duration_type || "N/A"}
                              </td>
                            </tr>
                            {showdefault.subscription_plan?.benefits?.length > 0 ? (
                              <tr>
                                <th>{t("label_benefits")}</th>
                                <td>{showdefault.subscription_plan.benefits.join(", ")}</td>
                              </tr>
                            ) : null}
                            {showdefault.subscription_plan?.subscription_access?.length > 0 ? (
                              <tr>
                                <th>{t("subscription_access")}</th>
                                <td>
                                  {showdefault.subscription_plan.subscription_access
                                    .map((a) =>
                                      a?.label && a?.value ? `${a.label}: ${a.value}` : a?.label || a?.value || ""
                                    )
                                    .filter(Boolean)
                                    .join(", ") || "N/A"}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                      </>
                    ) : null}

                    {/* ── Linked User Subscription ── */}
                    {/* {showdefault?.user_subscription && Object.keys(showdefault.user_subscription).length > 0 ? (
                      <>
                        <h6 className="main-content-label mb-2 mt-3">Linked Subscription Record</h6>
                        <table className="table table-bordered table-hover mb-4">
                          <tbody>
                            <tr>
                              <th style={{ width: "30%" }}>{t("list_heading_title")}</th>
                              <td>{showdefault.user_subscription?.title || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("list_heading_price")}</th>
                              <td>
                                {showdefault.user_subscription?.price !== null &&
                                showdefault.user_subscription?.price !== undefined
                                  ? `$${showdefault.user_subscription.price}`
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>Start Date</th>
                              <td>
                                {showdefault.user_subscription?.start_date
                                  ? formateDateWithMonth(showdefault.user_subscription.start_date)
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>End Date</th>
                              <td>
                                {showdefault.user_subscription?.end_date
                                  ? formateDateWithMonth(showdefault.user_subscription.end_date)
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>Activated</th>
                              <td>
                                <span
                                  className={`badge ${
                                    showdefault.user_subscription?.activated
                                      ? "badge-success"
                                      : "badge-danger"
                                  }`}
                                >
                                  {showdefault.user_subscription?.activated ? "Yes" : "No"}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <th>Verified</th>
                              <td>
                                <span
                                  className={`badge ${
                                    showdefault.user_subscription?.verified
                                      ? "badge-success"
                                      : "badge-warning"
                                  }`}
                                >
                                  {showdefault.user_subscription?.verified ? "Yes" : "No"}
                                </span>
                              </td>
                            </tr>
                            {showdefault.user_subscription?.platform ? (
                              <tr>
                                <th>Platform</th>
                                <td className="text-capitalize">
                                  {showdefault.user_subscription.platform}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                      </>
                    ) : null} */}

                    <div className="mt-3">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IapTransactionView;
